import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import { SvgChevrondown } from '@common/icon';
interface FilterProps {
  label: string;
  onClick: () => void;
}
export const Filter = t0 => {
  const $ = _c(6);
  const {
    label,
    onClick
  } = t0;
  let t1;
  if ($[0] !== label) {
    t1 = <span className="font-400 text-Gray-900 typo-body4">{label}</span>;
    $[0] = label;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgChevrondown className="size-12" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClick || $[4] !== t1) {
    t3 = <Button className="flex items-center gap-8" onClick={onClick} theme="sub-text" dimensions="H40">{t1}{t2}</Button>;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};